module.exports = __webpack_public_path__ + "img/leo.e67116d4.jpg";